import { Component, Input, OnInit } from '@angular/core';
import { LOOKUP } from 'src/app/models/common';
import { AdministrationSummaryService } from 'src/app/services/administration/administration-summary.service';
import { Subject } from 'rxjs';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { CommonService } from 'src/app/services/common.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-lookups-add-multiple',
  templateUrl: './lookups-add-multiple.component.html',
  styleUrls: ['./lookups-add-multiple.component.scss']
})
export class LookupsAddMultipleComponent implements OnInit {

  @Input() public Content: any;
  lookuptext: string = "";
 // content: any;
  //heading: string;
  addNewForm: UntypedFormGroup;
  isAllowNew: boolean = false;
  lookupList: LOOKUP[];
  lookUp: LOOKUP;
  action: Subject<any> = new Subject();

  constructor(public modalRef: NgbActiveModal,
    private summaryService: AdministrationSummaryService,
    private modalService: NgbModal,
    private commonService: CommonService,
  ) { }

  ngOnInit() {
    this.addNewForm = new UntypedFormGroup(
      {
        SUPPORTVALUE: new UntypedFormControl("", [Validators.required, Validators.maxLength(50)]),
        STATUS: new UntypedFormControl(true)
      });

    if (this.Content.heading == "Edit") {
      this.isAllowNew = true;
      // this.addNewForm.controls['SUPPORTVALUE'].disable();
      this.addNewForm.patchValue({
        SUPPORTVALUE: this.Content.Name,
        STATUS: this.Content.RecordState
      });
    } else {
      this.Content.heading = "Add";
    }
  }

  getLookups() {
    this.summaryService.getLookupsSummary(this.Content.id).subscribe(summary => {
      this.lookupList = summary;
    });
  }

  save(): void {
     
    let lookup: any;
    let hasValue: boolean = false;
    let text = this.addNewForm.controls['SUPPORTVALUE'].value;
    if (text.trim() != ""&& text != null&& text != undefined) {
      if (text.length > 50) {
        this.commonService.ValidationBanner("Exceeds Lookup Maximum length 50");
        return;
      }
      else if (text !== "" && text.length <= 50) {
        lookup = new LOOKUP();
        lookup.ID = this.Content.ID == null ? this.CreateGuid():this.Content.ID;
        lookup.LOOKUP_TYPE_ID = this.Content.id;
        lookup.CODE = this.Content.CODE;
        lookup.EXTENDABLE = this.Content.EXTENDABLE;
        lookup.NAME = text.trim();
        lookup.RECORD_STATE = this.addNewForm.controls['STATUS'].value == true ? 1 : 0;
      }

      if (!this.isAllowNew) {
        this.summaryService.insert(lookup).subscribe(summary => {
          if(summary.Status == 0){
            this.Content.list.forEach((element: any) => {
              let ele: string = element.NAME;
              let lkp: string = lookup.NAME;
             if(ele.toLowerCase() == lkp.toLowerCase()){
                this.commonService.ValidationBanner('The ' + "'" + lookup.NAME + "'" + ' already exists. Please update details to save the value');
              hasValue = true;
              }
            });
            if(!hasValue){
              //this.commonService.SuccessBanner(text + ' details inserted successfully');
             // this.action.next(lookup);
              this.modalRef.close(lookup);
            }
          } else{
            this.commonService.ValidationBanner(summary.Message);
            // this.modalService.show(MessageBoxComponent, { data: { heading: 'Validation Message(s)', content: { heading: '', description: summary.Message } } });
          }

        });
      } else {
        let isExist = this.Content.list.find(x => x.NAME == lookup.NAME && x.RECORD_STATE == lookup.RECORD_STATE);
        // this.content.list.forEach((element: any) => {
        //   let ele: string = element.NAME;
        //   let lkp: string = lookup.NAME;
         if(isExist && this.Content.Name == lookup.NAME){
         // this.commonService.ValidationBanner("No changes have been Performed");
            //this.modalService.show(MessageBoxComponent, { data: { heading: 'Validation Message(s)', content: { heading: '', description: 'No changes have been Performed' } } });
            hasValue = false;
          }

          if(isExist &&  this.Content.Name != lookup.NAME){
            this.commonService.ValidationBanner("The '" + lookup.NAME + "' already exists. Please update details to save the value");
            //this.modalService.show(MessageBoxComponent, { data: { heading: 'Validation Message(s)', content: { heading: '', description: 'The ' + lookup.NAME + ' already exists. Please update details to save the value' } } });
            hasValue = true;
          }
        // });
        if(!hasValue){
          //this.action.next(lookup);
          this.modalRef.close(lookup);
        }
      }
    } else {
      this.commonService.ValidationBanner("Please enter Supported Value");
      //this.modalService.show(MessageBoxComponent, { data: { heading: 'Validation Message(s)', content: { heading: '', description: 'Please enter Supported Value' } } });
    }
  }
  CreateGuid(): string {
    return this.p8(false) + this.p8(true) + this.p8(true) + this.p8(false);
  }
  public p8(s: boolean): string {
    var p = (Math.random().toString(16) + "000000000").substr(2, 8);
    return s ? "-" + p.substr(0, 4) + "-" + p.substr(4, 4) : p;
  }

  close() {
    this.canExit().then((x)=>{
      this.modalRef.dismiss();
    });
  }
  canExit() {
    if (this.addNewForm && this.Content.heading == "Edit") {
      return this.commonService.CanDeactivateBanner();
    }
    else {
      return Promise.resolve(true);
    }
  }
}
